export default __webpack_public_path__ + "9b992d4548195c35d342acb90a8fedac.png";